import { get } from "../../utils";

const errores = {
  "mensaje-0":
    '<p class="titulo medium p32" tabindex="0">Algo salió mal</p><p class="titulo" tabindex="0">En este momento el servicio no se encuentra disponible. Por favor, volvé a intentarlo más tarde.</p>',
  "mensaje-1":
    '<p class="titulo" tabindex="0">En este momento no tenemos ningún producto para ofrecerte</p>',
  "mensaje-2":
    '<p class="titulo" tabindex="0">En este momento no tenemos ningún producto para ofrecerte</p>',
  "mensaje-3":
    '<p class="titulo" tabindex="0">En este momento no tenemos ningún producto para ofrecerte</p>',
  "mensaje-4":
    '<p class="titulo medium p32" tabindex="0">Algo salió mal</p><p class="titulo" tabindex="0">En este momento el servicio no se encuentra disponible. Por favor, volvé a intentarlo más tarde.</p>',
  "mensaje-5":
    '<p class="titulo" tabindex="0">Alguno de los datos que ingresaste no son correctos</p></p class="titulo" tabindex="0">Verificalos y volvé a intentarlo</p>',
  "mensaje-6":
    '<p class="titulo" tabindex="0">Tenemos un producto para ofrecerte!, nos contactaremos a la brevedad</p>',
  "mensaje-7":
    '<p class="titulo" tabindex="0">Ya tenés una solicitud en curso</p>',
  "mensaje-8":
    '<p class="titulo" tabindex="0">En este momento no tenemos ningún producto para ofrecerte</p>',
  "mensaje-11":
    '<p class="titulo medium p32" tabindex="0">Algo salió mal</p><p class="titulo" tabindex="0">En este momento el servicio no se encuentra disponible. Por favor, volvé a intentarlo más tarde.</p>',
  "mensaje-12":
    '<p class="titulo medium p32" tabindex="0">Algo salió mal</p><p class="titulo" tabindex="0">En este momento el servicio no se encuentra disponible. Por favor, volvé a intentarlo más tarde.</p>',
  "mensaje-13":
    '<p class="titulo medium p32" tabindex="0">Algo salió mal</p><p class="titulo" tabindex="0">En este momento el servicio no se encuentra disponible. Por favor, volvé a intentarlo más tarde.</p>',
  ACTUALIZAR_DATOS_RENAPER:
    '<p class="titulo medium p32" tabindex="0">Algo salió mal</p><p class="titulo" tabindex="0">En este momento no pudimos validar tus datos. Por favor, volvé a intentarlo más tarde.</p>',
  DATOS_PERSONALES_INCORRECTOS:
    '<p class="titulo medium p32" tabindex="0">Atención</p><p class="titulo" tabindex="0">Los datos ingresados no son válidos. Por favor verifíquelos y vuelva a intentarlo.</p>',
  individuoNegativo:
    '<p class="titulo medium p32" tabindex="0">Registramos que ya ten&eacute;s una oferta en curso en el banco.</p><p class="titulo book p15" tabindex="0">Acercate a la sucursal donde iniciaste la solicitud.</p>',
  datosIncorrectos:
    '<p class="titulo medium p32" tabindex="0">Registramos que ya ten&eacute;s una oferta en curso en el banco.</p><p class="titulo book p15" tabindex="0">Acercate a la sucursal donde iniciaste la solicitud.</p>',
  RECHAZO_F_01:
    '<p class="titulo medium p32" tabindex="0">Registramos que ya ten&eacute;s una oferta en curso en el banco.</p><p class="titulo book p15" tabindex="0">Acercate a la sucursal donde iniciaste la solicitud.</p>',
  residenteTemporal:
    '<p class="titulo medium p32" tabindex="0">En este momento no podemos ofrecerte un préstamo.</p><p class="titulo book p15" tabindex="0">Para más información, acercate a la sucursal más cercana o comunicate al 0810-222-0000 de lunes a viernes de 9 a 19 hs.</p>',
  rechazoAntecedentes:
    '<p class="titulo medium p32" tabindex="0">En este momento no podemos ofrecerte un préstamo.</p><p class="titulo book p15" tabindex="0">Para más información, acercate a la sucursal más cercana o comunicate al 0810-222-0000 de lunes a viernes de 9 a 19 hs.</p>',
  RECHAZO_02:
    '<p class="titulo medium p32" tabindex="0">En este momento no podemos ofrecerte un préstamo.</p><p class="titulo book p15" tabindex="0">Para más información, acercate a la sucursal más cercana o comunicate al 0810-222-0000 de lunes a viernes de 9 a 19 hs.</p>',
  RECHAZO_07:
    '<p class="titulo medium p32" tabindex="0">En este momento no podemos ofrecerte un préstamo.</p><p class="titulo book p15" tabindex="0">Para más información, acercate a la sucursal más cercana o comunicate al 0810-222-0000 de lunes a viernes de 9 a 19 hs.</p>',
  RECHAZO_704:
    '<p class="titulo medium p32" tabindex="0">En este momento no podemos ofrecerte un préstamo.</p><p class="titulo book p15" tabindex="0">Para más información, acercate a la sucursal más cercana o comunicate al 0810-222-0000 de lunes a viernes de 9 a 19 hs.</p>',
  SIN_PRESTAMOS_DISPONIBLES:
    '<p class="titulo medium p32" tabindex="0">En este momento no tenemos ningún producto para ofrecerte.</p><p class="titulo book p15" tabindex="0">Para más información, acercate a la sucursal más cercana o comunicate al 0810-222-0000 de lunes a viernes de 9 a 19 hs.</p>',
  calificacionInvalida:
    '<p class="titulo medium p32" tabindex="0">En este momento no podemos ofrecerte un préstamo.</p><p class="titulo book p15" tabindex="0">Para más información, comunicate al 0810-222-0000 de lunes a viernes de 9 a 19 hs. También podés volver a intentar más adelante.</p>',
  CALIFICACION_INVALIDA:
    '<p class="titulo medium p32" tabindex="0">En este momento no podemos ofrecerte un préstamo.</p><p class="titulo book p15" tabindex="0">Para más información, comunicate al 0810-222-0000 de lunes a viernes de 9 a 19 hs. También podés volver a intentar más adelante.</p>',
  RECHAZO_703:
    '<p class="titulo medium p32" tabindex="0">En este momento no podemos ofrecerte un préstamo.</p><p class="titulo book p15" tabindex="0">Para más información, comunicate al 0810-222-0000 de lunes a viernes de 9 a 19 hs. También podés volver a intentar más adelante.</p>',
  RECHAZO_04:
    '<p class="titulo medium p32" tabindex="0">En este momento no podemos ofrecerte un préstamo.</p><p class="titulo book p15" tabindex="0">Para más información, comunicate al 0810-222-0000 de lunes a viernes de 9 a 19 hs. También podés volver a intentar más adelante.</p>',
  RECHAZO_05:
    '<p class="titulo medium p32" tabindex="0">En este momento no podemos ofrecerte un préstamo.</p><p class="titulo book p15" tabindex="0">Para más información, comunicate al 0810-222-0000 de lunes a viernes de 9 a 19 hs. También podés volver a intentar más adelante.</p>',
  RECHAZO_06:
    '<p class="titulo medium p32" tabindex="0">En este momento no podemos ofrecerte un préstamo.</p><p class="titulo book p15" tabindex="0">Para más información, comunicate al 0810-222-0000 de lunes a viernes de 9 a 19 hs. También podés volver a intentar más adelante.</p>',
  RECHAZO_08:
    '<p class="titulo medium p32" tabindex="0">En este momento no podemos ofrecerte un préstamo.</p><p class="titulo book p15" tabindex="0">Para más información, comunicate al 0810-222-0000 de lunes a viernes de 9 a 19 hs. También podés volver a intentar más adelante.</p>',
  RECHAZO_10:
    '<p class="titulo medium p32" tabindex="0">En este momento no podemos ofrecerte un préstamo.</p><p class="titulo book p15" tabindex="0">Para más información, comunicate al 0810-222-0000 de lunes a viernes de 9 a 19 hs. También podés volver a intentar más adelante.</p>',
  RECHAZO_11:
    '<p class="titulo medium p32" tabindex="0">En este momento no podemos ofrecerte un préstamo.</p><p class="titulo book p15" tabindex="0">Para más información, comunicate al 0810-222-0000 de lunes a viernes de 9 a 19 hs. También podés volver a intentar más adelante.</p>',
  RECHAZO_12:
    '<p class="titulo medium p32" tabindex="0">En este momento no podemos ofrecerte un préstamo.</p><p class="titulo book p15" tabindex="0">Para más información, comunicate al 0810-222-0000 de lunes a viernes de 9 a 19 hs. También podés volver a intentar más adelante.</p>',
  RECHAZO_13:
    '<p class="titulo medium p32" tabindex="0">En este momento no podemos ofrecerte un préstamo.</p><p class="titulo book p15" tabindex="0">Para más información, comunicate al 0810-222-0000 de lunes a viernes de 9 a 19 hs. También podés volver a intentar más adelante.</p>',
  RECHAZO_702:
    '<p class="titulo medium p32" tabindex="0">En este momento no podemos ofrecerte un préstamo.</p><p class="titulo book p15" tabindex="0">Para más información, comunicate al 0810-222-0000 de lunes a viernes de 9 a 19 hs. También podés volver a intentar más adelante.</p>',
  RECHAZO_03:
    '<p class="titulo medium p32" tabindex="0">Algo salió mal</p><p class="titulo book p15" tabindex="0">En este momento el servicio no se encuentra disponible. Por favor, volvé a intentarlo más tarde.</p>',
  RECHAZO_701:
    '<p class="titulo medium p32" tabindex="0">Algo salió mal</p><p class="titulo book p15" tabindex="0">En este momento el servicio no se encuentra disponible. Por favor, volvé a intentarlo más tarde.</p>',
  errorGeneral:
    '<p class="titulo medium p32" tabindex="0">Algo salió mal</p><p class="titulo book p15" tabindex="0">En este momento el servicio no se encuentra disponible. Por favor, volvé a intentarlo más tarde.</p>',
  RECHAZO_F_02:
    '<p class="titulo medium p32" tabindex="0">Tenemos una oferta para vos</p><p class="titulo book p15" tabindex="0">Entr&aacute; al homebanking y consult&aacute; tu oferta</p>',
  RECHAZO_F_03:
    '<p class="titulo medium p32" tabindex="0">Tenemos una oferta para vos</p><p class="titulo book p15" tabindex="0">Entr&aacute; al homebanking y consult&aacute; tu oferta</p>',
  "error-dni": {
    text: "<p>Comprobá que tus fotos estén bien enfocadas.</p>"
  },
  "error-selfie": {
    text: "<p>Comprobá que tus fotos estén bien enfocadas.</p>"
  },
  "error-inicio-veridas": {
    text: '<p tabindex="0">No pudimos detectar una cámara en tu dispositivo.<br>Por favor, intentá desde otro dispositivo .</p>'
  },
  "habilita-permisos": {
    text: '<p class="titulo">Te pedimos que habilites los permisos de tu navegador para poder acceder a la cámara del dispositivo.</p>'
  },
  "error-tokenExpired": {
    text: '<p tabindex="0">No fue posible inicar la validación, te pedimos por favor que lo vuelvas a intentar.</p>'
  },
  "error-servicio-veridas": {
    text: '<p tabindex="0">Tuvimos un problema volvé a intentar más tarde</p>'
  },
  "error-servicio-aso": {
    text: "<p>Tuvimos un problema volvé a intentar más tarde</p>"
  },
  "error-servicio-renaper": {
    text: '<p tabindex="0">Tuvimos un problema volvé a intentar más tarde</p>'
  },
  "error-veridas-result": {
    text: '<p tabindex="0">¡Probá nuevamente!<br>Comprobá que tus fotos estén bien enfocadas</p>'
  },
  "error-reintentos-biometria": {
    text: '<p class="mensaje-error" tabindex="0">Bloqueamos este proceso para proteger tus datos. Podés volver a intentar más tarde</p>'
  },
  "error-servidor": {
    text: '<p class="mensaje-error" tabindex="0">Por favor volvé a intentar más tarde</p>'
  },
  "error-conexion": {
    text: '<p tabindex="0">Asegurate de tener una conexión estable.</p>'
  },
  ERROR_SIMULACION_PH:
    '<h1 class="titulo medium p32" tabindex="0">No pudimos cargar la información</h1><div class="subtitulo"><p class="titulo book p15" tabindex="0">Tuvimos un problema y estamos trabajando para solucionarlo.<br>Podés intentarlo nuevamente, o si lo preferís, acercate a tu sucursal BBVA más cercana para recibir asesoramiento especializado.</p></div>',
  ERROR_CONFIRMACION_SIMULACION_PH:
    '<h1 class="titulo medium p32" tabindex="0">No pudimos completar la solicitud</h1><div class="subtitulo"><p class="titulo book p15" tabindex="0">Tuvimos un problema y estamos trabajando para solucionarlo.<br>Podés intentarlo nuevamente, o si lo preferís, acercate a tu sucursal BBVA más cercana para recibir asesoramiento especializado.</p></div>',
  ERROR_PRESCRIPTOR:
    '<h1 class="titulo medium p32" tabindex="0">No pudimos cargar la información</h1><div class="subtitulo"><p class="titulo book p15" tabindex="0">Tuvimos un problema y estamos trabajando para solucionarlo.<br>Podés intentarlo nuevamente.</p></div>',
  ERROR_GENERICO:
    '<h1 class="titulo medium p32" tabindex="0">No pudimos completar la solicitud</h1><div class="subtitulo"><p class="titulo book p15" tabindex="0">Tuvimos un problema y estamos trabajando para solucionarlo.<br>Podés intentarlo nuevamente.</p></div>',
  ERROR_CODIGO_RECHAZADO:
    '<h1 class="titulo medium p32" tabindex="0">El código ingresado no existe</h1><div class="subtitulo"><p class="titulo book p15" tabindex="0">No encontramos el código de prescriptor que ingresaste. Revisá la información y volvé a intentarlo.</p></div>'
};

const erroresContratacion = {
  CLE0534: {
    mensaje: "error-celular",
    errorType: "error datos prefijo erroneo"
  },
  CLE0535: {
    mensaje: "error-celular",
    errorType: "error numero de telefono"
  },
  CLE0536: {
    mensaje: "error-celular",
    errorType: "error caracteristica telefono"
  },
  CLE0537: {
    mensaje: "error-celular",
    errorType: "error telefono cero"
  },
  CLE0538: {
    mensaje: "error-celular",
    errorType: "error telefono base negativa"
  },
  CLE1296: {
    mensaje: "error-celular",
    errorType: "error telefono fijo como celular"
  },
  CLE0886: {
    mensaje: "error-domicilio",
    errorType: "error puerta domicilio"
  },
  CLE0361: {
    mensaje: "error-domicilio",
    errorType: "error caracteres calle"
  },
  CLE0061: {
    mensaje: "error-domicilio",
    errorType: "error domicilio y codigo postal"
  },
  JCLE530: {
    mensaje: "error-conyuge",
    errorType: "error documento conyuge"
  },
  JCLE405: {
    mensaje: "error-email",
    errorType: "error correo electronico"
  }
};

/**
 * Determinar pantalla de error de acuerdo a la
 * respuesta de confirmación de OM
 * @param {array de errores} errores
 */
export const getParamMensajeContratacion = (errores, campo = "mensaje") => {
  // Obtengo la lista de errores que vienen en la confirmación y filtro
  // por código que viene en paréntesis
  const listaErrores = errores.map(error => {
    const _match = error.match(/\(([^()]+)\)/);
    return get(_match, "[1]", error);
  });
  // Filtro por map obteniendo el primer error y por defecto mando a mensaje-4
  return get(
    erroresContratacion,
    `${get(listaErrores, "[0]", null)}.${campo}`,
    campo === "mensaje" ? "mensaje-4" : "error tecnico"
  );
};

export default errores;
